/* Spanish catalog mirroring locale-projects-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'pj.tab.time': 'Hoja de horas',
  'pj.tab.overview': 'Resumen',
  'pj.tab.settings': 'Ajustes',
  'pj.day.mon': 'Lun',
  'pj.day.tue': 'Mar',
  'pj.day.wed': 'Mié',
  'pj.day.thu': 'Jue',
  'pj.day.fri': 'Vie',
  'pj.day.sat': 'Sáb',
  'pj.day.sun': 'Dom',
  'pj.person.fallback': 'tú',
  'pj.time.title': 'Hoja de horas de {name}',
  'pj.week.label': 'Semana {week}',
  'pj.week.word': 'Semana',
  'pj.week.pick': 'Elegir semana',
  'pj.week.current': 'Esta semana',
  'pj.week.back': 'Tres semanas atrás',
  'pj.week.forward': 'Tres semanas adelante',
  'pj.week.prev': 'Semana anterior',
  'pj.week.next': 'Semana siguiente',
  'pj.month.prev': 'Mes anterior',
  'pj.month.next': 'Mes siguiente',
  'pj.month.entries': 'Horas registradas en {month}',
  'pj.month.dayHours': '{hours} registradas',
  'pj.view.day': 'Día',
  'pj.view.week': 'Semana',
  'pj.day.empty': 'No hay horas registradas en este día.',
  'pj.table.projectActivity': 'Proyecto / actividad',
  'pj.table.sum': 'Total',
  'pj.table.hours': 'Horas',
  'pj.row.new': 'Nueva fila',
  'pj.row.add': 'Añadir',
  'pj.row.remove': 'Eliminar la fila',
  'pj.row.pickBoth': 'Elige un proyecto y una actividad',
  'pj.select.project': 'Elige un proyecto …',
  'pj.select.activity': 'Elige una actividad …',
  'pj.select.projectSearch': 'Buscar un proyecto …',
  'pj.select.activitySearch': 'Buscar una actividad …',
  'pj.select.projectEmpty': 'Ningún proyecto coincide con la búsqueda.',
  'pj.select.activityEmpty': 'Ninguna actividad coincide con la búsqueda.',
  'pj.project.createAction': 'Crear un proyecto nuevo',
  'pj.activity.createAction': 'Crear una actividad nueva',
  'pj.activity.none': 'Este proyecto aún no tiene actividades. Crea una aquí.',
  'pj.lock.state.done': 'La hoja de horas está marcada como finalizada hasta el {date}.',
  'pj.lock.state.open': 'La hoja de horas no está marcada como finalizada',
  'pj.lock.markWeek': 'Marcar como finalizada hasta la semana {week}',
  'pj.lock.undo': 'Deshacer',
  'pj.lock.done': 'La hoja de horas está marcada como finalizada hasta la semana {week}',
  'pj.lock.undone': 'La hoja de horas está abierta de nuevo',
  'pj.entry.newTitle': 'Nuevo registro de horas',
  'pj.entry.editTitle': 'Editar registro de horas',
  'pj.entry.invoicedLocked': 'Estas horas están facturadas y no se pueden modificar. Elimina o abona el borrador de factura para liberarlas.',
  'pj.entry.periodLocked': 'La hoja de horas de este periodo está marcada como finalizada.',
  'pj.entry.invoicedShort': 'Facturado',
  'pj.field.project': 'Proyecto',
  'pj.field.activity': 'Actividad',
  'pj.field.hours': 'Horas',
  'pj.field.date': 'Fecha',
  'pj.field.description': 'Descripción',
  'pj.field.descriptionHint': '¿A qué se dedicaron las horas? El texto pasa a la factura.',
  'pj.field.name': 'Nombre',
  'pj.field.number': 'Número',
  'pj.field.customer': 'Cliente',
  'pj.field.contact': 'Persona de contacto',
  'pj.field.optional': 'Opcional',
  'pj.field.defaultActivity': 'Actividad predeterminada',
  'pj.field.product': 'Producto',
  'pj.field.rate': 'Tarifa por hora',
  'pj.field.start': 'Inicio',
  'pj.field.end': 'Fin',
  'pj.field.color': 'Color',
  'pj.field.status': 'Estado',
  'pj.overview.title': 'Resumen de horas',
  'pj.overview.week': 'Resumen semanal',
  'pj.overview.month': 'Resumen mensual',
  'pj.overview.reports': 'Informes',
  'pj.overview.total': 'Total registrado',
  'pj.overview.billable': '{hours} facturables',
  'pj.overview.weekEntries': 'Horas registradas en la semana {week}',
  'pj.overview.empty': 'No hay horas registradas en el periodo',
  'pj.overview.emptyTitle': 'Sin horas',
  'pj.filter.all': 'Todos',
  'pj.filter.period': 'Periodo',
  'pj.filter.billing': 'Facturación',
  'pj.filter.billable': 'Facturable',
  'pj.filter.nonBillable': 'No facturable',
  'pj.filter.invoicedLabel': 'Facturado',
  'pj.filter.invoiced': 'Facturado',
  'pj.filter.open': 'Sin facturar',
  'pj.report.title': 'Horas registradas del {from} al {to}',
  'pj.report.emptyTitle': 'Sin registros',
  'pj.report.emptyText': 'No hay horas en el periodo y filtro seleccionados.',
  'pj.report.print': 'Imprimir',
  'pj.report.pdf': 'Descargar como PDF',
  'pj.report.pdfTitle': 'Informe de horas',
  'pj.report.pdfError': 'No se pudo descargar el informe.',
  'pj.report.pdfUnavailable': 'El PDF del informe no está conectado al backend.',
  'pj.report.opening': 'Abriendo la impresión ...',
  'pj.basis.title': 'Base de facturación',
  'pj.basis.projectName': 'Nombre del proyecto',
  'pj.basis.searchPlaceholder': 'Proyecto, cliente …',
  'pj.basis.summary': '{count} registros sin facturar del {from} al {to}',
  'pj.basis.selected': 'Seleccionado',
  'pj.basis.costs': 'Gastos a refacturar',
  'pj.basis.costText': 'Gasto',
  'pj.basis.costSource': 'Origen',
  'pj.basis.costAmount': 'Importe',
  'pj.basis.costEmployee': 'Gasto de empleado · {name}',
  'pj.basis.costPurchase': 'Compra contabilizada',
  'pj.basis.timesheet': 'Adjuntar una hoja de horas',
  'pj.basis.create': 'Crear borrador de factura',
  'pj.basis.created': 'Borrador de factura creado para {project}',
  'pj.basis.pickOne': 'Elige al menos un registro',
  'pj.basis.error': 'No se pudo crear el borrador de factura.',
  'pj.basis.emptyTitle': 'No hay horas sin facturar',
  'pj.basis.emptyText': 'Todo está facturado, o aún no se han registrado horas facturables en proyectos con cliente.',
  'pj.cost.tab': 'Gastos',
  'pj.cost.title': 'Gastos del proyecto',
  'pj.cost.party': 'Empleado / proveedor',
  'pj.cost.voucher': 'Justificante',
  'pj.cost.openVoucher': 'Ver justificante',
  'pj.cost.noVoucher': 'El justificante no está disponible',
  'pj.cost.noVoucherHelp': 'El coste no tiene ningún archivo adjunto.',
  'pj.cost.noVoucherShort': 'Sin justificante',
  'pj.cost.pending': 'Pendiente de aprobación',
  'pj.cost.invoiced': 'Facturado',
  'pj.cost.notBillable': 'No facturable',
  'pj.cost.toInvoice': 'Por facturar',
  'pj.cost.searchLabel': 'Buscar',
  'pj.cost.searchPlaceholder': 'Descripción, empleado, proveedor …',
  'pj.cost.openSum': '{amount} por facturar',
  'pj.cost.totalAll': 'Total de todas las coincidencias',
  'pj.cost.emptyTitle': 'Sin gastos',
  'pj.cost.emptyText': 'Aún no hay costes vinculados a un proyecto. Los justificantes se vinculan a un proyecto en la bandeja de entrada, en la compra o cuando el empleado envía el gasto.',
  'pj.billing.always': 'Siempre',
  'pj.billing.ask': 'Preguntar',
  'pj.billing.never': 'Nunca',
  'pj.activity.newTitle': 'Nueva actividad',
  'pj.activity.editTitle': 'Editar actividad',
  'pj.activity.namePlaceholder': 'P. ej. Consultoría',
  'pj.activity.noProduct': 'Ninguno',
  'pj.activity.productHint': 'Las horas se facturan como «{product}» y se contabilizan en la cuenta {account}.',
  'pj.activity.noProductHint': 'Sin producto, las horas se contabilizan como servicios en la cuenta 3020 con el tipo de IVA estándar.',
  'pj.activity.rateHint': 'Sin IVA. Si se deja vacío, se usa el precio del producto.',
  'pj.activity.neverHint': 'Las horas quedan fuera de la base de facturación. Úsalo para vacaciones y trabajo interno.',
  'pj.project.newTitle': 'Crear un proyecto nuevo',
  'pj.project.newShort': 'Nuevo proyecto',
  'pj.project.editTitle': 'Editar proyecto',
  'pj.project.numberHint': 'Sugerido: {number}',
  'pj.project.customerHint': 'Sin cliente no se pueden facturar las horas.',
  'pj.project.noCustomer': 'Sin cliente (proyecto interno)',
  'pj.project.closed': 'Cerrado',
  'pj.settings.title': 'Ajustes de la hoja de horas',
  'pj.settings.activities': 'Actividades',
  'pj.settings.projects': 'Proyectos',
  'pj.settings.noActivitiesTitle': 'Aún no hay actividades',
  'pj.settings.noActivitiesText': 'La actividad determina la tarifa por hora y el producto con el que se facturan las horas.',
  'pj.settings.noProjectsFirst': 'Crea primero un proyecto.',
  'pj.settings.noProjectsTitle': 'Aún no hay proyectos',
  'pj.settings.noProjectsText': 'Crea un proyecto para empezar a registrar horas.',
  'pj.toast.entrySaved': 'Las horas se han registrado',
  'pj.toast.entryUpdated': 'El registro de horas se ha actualizado',
  'pj.toast.entryDeleted': 'El registro de horas se ha eliminado',
  'pj.toast.activitySaved': 'La actividad se ha guardado',
  'pj.toast.activityDeleted': 'La actividad se ha eliminado',
  'pj.toast.projectSaved': 'El proyecto se ha guardado',
  'pj.toast.projectDeleted': 'El proyecto se ha eliminado',
  'pj.error.saveEntry': 'No se pudo guardar el registro de horas.',
  'pj.error.deleteEntry': 'No se pudo eliminar el registro de horas.',
  'pj.error.saveRows': 'No se pudieron actualizar las filas.',
  'pj.error.lock': 'No se pudo actualizar el bloqueo.',
  'pj.error.saveActivity': 'No se pudo guardar la actividad.',
  'pj.error.deleteActivity': 'No se pudo eliminar la actividad.',
  'pj.error.saveProject': 'No se pudo guardar el proyecto.',
  'pj.error.deleteProject': 'No se pudo eliminar el proyecto.',
  'pj.validation.projectName': 'El proyecto necesita un nombre.',
  'pj.validation.endBeforeStart': 'La fecha de fin no puede ser anterior a la fecha de inicio.',
  'pj.validation.activityName': 'La actividad necesita un nombre.',
  'pj.validation.activityProject': 'La actividad debe pertenecer a un proyecto.',
  'pj.validation.entryDate': 'El registro de horas necesita una fecha.',
  'pj.validation.entryHours': 'El número de horas debe ser mayor que 0.',
  'pj.validation.entryHoursMax': 'Un solo registro no puede superar las 24 horas.',
  'pj.validation.entryNotFound': 'No se encontró el registro de horas.',
  'pj.validation.entryInvoiced': 'El registro de horas ya está facturado y no se puede modificar.',
  'pj.validation.periodLocked': 'La hoja de horas de este periodo está marcada como finalizada.',
  'svc.projectNotFound': 'No se encontró el proyecto.',
  'svc.projectNumberTaken': 'Ese número de proyecto ya está en uso.',
  'svc.projectHasHours': 'El proyecto tiene horas registradas. Márcalo como cerrado en lugar de eliminarlo.',
  'svc.projectClosed': 'El proyecto está cerrado y no admite horas nuevas.',
  'svc.projectNeedsCustomer': 'El proyecto necesita un cliente para poder facturar las horas.',
  'svc.activityNotFound': 'No se encontró la actividad.',
  'svc.activityHasHours': 'La actividad tiene horas registradas y no se puede eliminar.',
  'svc.timeEntryNotFound': 'No se encontró el registro de horas.',
  'svc.timeTrackingLocked': 'La hoja de horas de este periodo está marcada como finalizada.',
  'svc.pickTimeEntries': 'Elige al menos un registro de horas sin facturar.',
  'svc.timesheetInvoiceDescription': 'Horas en {project} en el periodo del {from} al {to}.',
});
